import './TransactionLayoutScreen.scss';
import {useCallback, useState} from "react";
import CardComponent from "../../../shared/components/card/CardComponent";
import PendingPaymentListComponent from "../pending-payment/PendingPaymentListComponent";
import SelectDropdownComponent from "../../../shared/components/form-controls/select-dropdown/SelectDropdownComponent";
import moment from "moment";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import TabGroupComponent from "../../../shared/components/tab-group/TabGroupComponent";
import CompletedPaymentListComponent from "../completed-payment/CompletedPaymentList";
import DateRangePickerComponentV2 from "../../../shared/components/date-range-pickerV2/DateRangePickerComponentV2";
import momentTimezone from "moment-timezone";

interface TransactionLayoutScreenProps {

}

const tabs: any[] = [
    {
        id: 'pendingPayments',
        title: 'Pending Payments',
    },
    {
        id: 'completedPayments',
        title: 'Completed Payments',
    }
];

const TransactionLayoutScreen = (props: TransactionLayoutScreenProps) => {
    const [selectedTabId, setSelectedTabId] = useState(tabs[0].id);
    const [transactionsFilterState, setTransactionsFilterState] = useState<any>({
        service_id: undefined,
        date_range: [null, null],
        start_date: null,
        end_date: null,
        sort: {}
    });

    const {
        serviceList,
        isServiceListLoaded,
        isServiceListLoading,
    } = useSelector((state: IRootReducerState) => state.client);

    const handleTabChange = useCallback((tabId: string) => {
        setSelectedTabId(tabId);
    }, []);

    const handleSort = useCallback((key: string, order: string) => {
        setTransactionsFilterState((oldState: any) => {
            const newState = {...oldState};
            newState["sort"] = {
                key,
                order
            }
            return newState;
        })
    }, []);


    return (
        <div className="transaction-layout-screen">
            <div className="title">My Transactions</div>
            <CardComponent className={' mrg-bottom-0'}>
                <TabGroupComponent tabs={tabs} selectedTabId={selectedTabId} onTabSelection={handleTabChange}/>
                <div className="case-list-filters ts-row">
                    <div className="ts-col-lg-3">
                        <SelectDropdownComponent
                            size={"small"}
                            placeholder={"Service"}
                            options={serviceList}
                            value={transactionsFilterState?.service_id}
                            displayWith={(option: any) => option.name}
                            valueExtractor={(option: any) => option._id}
                            isDataLoading={isServiceListLoading}
                            isDataLoaded={isServiceListLoaded}
                            onUpdate={(value: any) => {
                                setTransactionsFilterState({
                                    ...transactionsFilterState,
                                    service_id: value
                                });
                            }}
                        />
                    </div>

                    <div className="ts-col-lg-6"/>
                    <div className={'ts-col-lg-3 '}>
                        <DateRangePickerComponentV2
                            value={transactionsFilterState?.date_range}
                            onDateChange={(value: any) => {
                                setTransactionsFilterState((prevState: any) => {
                                    if (value) {
                                        return {
                                            ...prevState,
                                            start_date: moment(value[0]).format('YYYY-MM-DD'),
                                            end_date: moment(value[1]).format('YYYY-MM-DD'),
                                            date_range: value,
                                            timezone: momentTimezone.tz.guess()
                                        };
                                    } else {
                                        const {date_range, start_date, end_date, ...rest} = prevState;
                                        return rest;
                                    }
                                });
                            }}
                        />
                    </div>
                </div>
                {
                    selectedTabId === 'pendingPayments' && (
                        <>
                            <PendingPaymentListComponent filterState={transactionsFilterState} onSort={handleSort}/>
                        </>
                    )
                }
                {
                    selectedTabId === 'completedPayments' && (
                        <>
                            <CompletedPaymentListComponent filterState={transactionsFilterState} onSort={handleSort}/>
                        </>
                    )
                }

            </CardComponent>

        </div>
    );
};

export default TransactionLayoutScreen;
